import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  Badge,
  Button,
  Cell,
  CellBody,
  CellFooter,
  CellHeader,
  Cells,
  CellsGroup,
  CellsTitle,
  Input,
  MediaBoxInfo
} from "../../components/weui";
import { selectMeters } from "../../stores";
import { urls } from "../../urls";

import "./index.css";

export const PayEntry = () =>{
  const navigate = useNavigate();
  const meters = useSelector(selectMeters);
  const [meterNo, setMeterNo] = useState("");

  const toPay = meterNo => {
    navigate(urls.recharge(meterNo));
  };

  return (
    <>
      <CellsGroup>
        <CellsTitle>帮别人缴费</CellsTitle>
        <Cells>
          <Cell vcode htmlFor="elMeterNo">
            <CellHeader>
              <span className="weui-label">表计编号</span>
            </CellHeader>
            <CellBody flex>
              <Input id="elMeterNo" className="self-center" type="number" cell placeholder="请输入表计编号" defaultValue={ meterNo } onChange={ e => setMeterNo(e.target.value) } />
              <Button className="pay-btn" disabled={ !meterNo } vcode onClick={ e => toPay(meterNo) }>缴费</Button>
            </CellBody>
          </Cell>
        </Cells>
        { /*<CellsTips>如需为未绑定的表计充值, 请输入表计编号后点击缴费按钮；如果为已绑定表计充值，直接点击下列表计即可。</CellsTips>*/ }

        <CellsTitle className="mt-10">我的表计</CellsTitle>
        <Cells>
          {
            meters.map(m =>
              <Cell access active onClick={ e => toPay(m.meterNo) } key={ m.meterNo }>
                <CellBody>
                  { m.name }
                  <MediaBoxInfo className="mt-2" infos={ [`${m.meterClass}`, `${m.meterNo}`, `|${m.corpName}`] } />
                </CellBody>
                <CellFooter>
                  <Badge className="px-2.5 py-1.5">缴费</Badge>
                </CellFooter>
              </Cell>
            )
          }
        </Cells>
      </CellsGroup>
    </>
  );
};
